import {ModalController} from '../common/modal.controller.js';


class NalazController {
    constructor($uibModal, Model) {
        this.$uibModal = $uibModal;
        this.ModelFactory = Model;
        this.items = [];
        this.pager = {
            currentPage: 1,
            limit: 15,
            totalItems: 0,
            search: "",
        };

        this.refreshState();
    }

    refreshState(){
        this.getItems();
    }

    insert() {
        const model = {};
        const modal = this.$uibModal.open({
            template: '<nalaz-form model="vm.model" on-submit="vm.submit(model)" on-cancel="vm.cancel()"></nalaz-form>',
            controller: ModalController,
            controllerAs: 'vm',
            size: 'lg',
            resolve : {
                model: function() {
                    return model;
                }
            },
        });

        modal.result.then((model) => {
            this.refreshState();
        });
    }

    edit(item) {
        const model = item;
        const modal = this.$uibModal.open({
            template: '<nalaz-form model="vm.model" on-submit="vm.submit(model)" on-cancel="vm.cancel()"></nalaz-form>',
            controller: ModalController,
            controllerAs: 'vm',
            resolve : {
                model: function() {
                    return model;
                }
            },
        });

        modal.result.then((model) => {
            this.refreshState();
        });
    }

    getItems() {
        const params = {
            limit: this.pager.limit,
            offset: 0,
            ordering: 'tip',
            search: this.pager.search,
        };

        if (params.search === '') {
            delete (params.search);
        }

        params.offset = (this.pager.currentPage - 1) * params.limit;

        this.ModelFactory.findAll(params, {bypassCache: true}).then((response) => {
            this.items = response;
            if (angular.isDefined(response.meta)) {
                this.pager.totalItems = response.meta.count;
            }
        });
    }

    onFilter(value) {
        this.pager.search = value;
        this.refreshState();
    }

    pageChanged() {
        this.refreshState();
    }


}

NalazController.$inject= ['$uibModal', 'Nalaz'];

export {NalazController};



// WEBPACK FOOTER //
// ./app/components/nalaz/nalaz.controller.js